"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailValidationSchema = exports.currentPasswordValidation = exports.passwordValidation = exports.passwordValidatorSchema = void 0;
var password_validator_1 = __importDefault(require("password-validator"));
var Yup = __importStar(require("yup"));
exports.passwordValidatorSchema = new password_validator_1.default();
exports.passwordValidatorSchema
    .is()
    .min(8)
    .is()
    .max(20)
    .has()
    .uppercase()
    .has()
    .lowercase()
    .has()
    .symbols()
    .has()
    .digits();
exports.passwordValidation = Yup.string()
    .test('password-validator', 'Enter valid password', function (value) { return !!value && !!exports.passwordValidatorSchema.validate(value); })
    .required()
    .max(20);
exports.currentPasswordValidation = Yup.string().required();
exports.emailValidationSchema = Yup.object().shape({
    email: Yup.string().required().email()
});
//# sourceMappingURL=validations.js.map